import React from 'react';
import { PropTypes } from 'prop-types';
import Drawer from 'material-ui/Drawer';
import Divider from 'material-ui/Divider';

import { CORE } from '../../../../constants/globals';

import CloseMenuItem from './CloseMenuItem';
import EditMenuItem from './EditMenuItem';
import DeleteCoreMenuItem  from './DeleteCoreMenuItem';
import { Material } from '../../../../models';

export const MenuDrawer = ({ open, onClose, target, lengthUnit }) =>  {
  const isCore = target && target.type === CORE;

  return (
    <div>
      <Drawer anchor="bottom" open={open} onClose={onClose}>
        <CloseMenuItem onClose={onClose} />
        <Divider />
        <EditMenuItem material={target} onClick={onClose} unit={lengthUnit} />
        {isCore ? ([
          <DeleteCoreMenuItem
            key="above"
            material={target}
            onClick={onClose}
            unit={lengthUnit}
            deletePrepregAbove
          />,
          <DeleteCoreMenuItem
            key="below"
            material={target}
            onClick={onClose}
            unit={lengthUnit}
            deletePrepregAbove={false}
          />
        ]): null}
      </Drawer>
    </div>
  )
}

MenuDrawer.defaultProps = {
  target: undefined,
}

MenuDrawer.propTypes = {
  open:       PropTypes.bool.isRequired,
  onClose:    PropTypes.func.isRequired,
  target:     PropTypes.instanceOf(Material),
  lengthUnit: PropTypes.string.isRequired,
}

export default MenuDrawer;



// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/MenuDrawer/MenuDrawer.js